import React from "react";
import NavBar from "@components/navBar/NavBar";
import Footer from "@components/footer/Footer";
import "./contact.scss";
import fetchApi from "@api/fetchApi";
import { useToast } from "@chakra-ui/react";

export function Contact() {
  const [form, setForm] = React.useState({
    name: "",
    email: "",
    message: "",
    subject: ""
  });

  const toast = useToast()

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    
    fetchApi.post('/contact', form)
    .then(() => {
      toast({
        title: "Message envoyé",
        description: "Votre message a bien été envoyé.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom-right",
      })

      setForm({
        email: "",
        message: "",
        name: "",
        subject: ""
      })
    })
    .catch((err) => {
      toast({
        title: "Erreur",
        description: "Une erreur est survenue lors de l'envoi de votre message.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-right",
      })
    })
  }

  return (
    <div id="contact">
      <NavBar />
      <main>
        <div>
          <h1>Contact</h1>
          <form onSubmit={handleSubmit}>
            <label>
              Votre nom :
              <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            </label>
            <label>
              Votre email (nous vous re-contacterons via celui-ci) :
              <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            </label>
            <label>
              Sujet :
              <input type="text" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required />
            </label>
            <label>
              Votre message :
              <textarea name="" id="" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required></textarea>
            </label>
            <aside>Les données de ce formulaire sont traitées comme un
              échange informationnel et ne sont partagées avec aucun
              tiers. Elles n’ont pas vocation à être conservées au-delà de
              trois mois.</aside>
            <button type="submit">Envoyer</button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
}